import { Alert, Typography, useTheme } from '@mui/material';
import { DoorBatteryWarningLevel } from 'graphql/generated/graphqlTypes';
import useBatteryStatusUI from 'hooks/useBatteryStatusUI/useBatteryStatusUI';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import Icon from 'ui/atoms/Icon/Icon';

export interface Props {
  batteryStatus: DoorBatteryWarningLevel;
  id?: string;
}

const BatteryStatusAlert: React.FC<React.PropsWithChildren<Props>> = ({ batteryStatus, id }) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const { getBatteryData } = useBatteryStatusUI(translation);

  const batteryData = getBatteryData(batteryStatus, theme);
  return (
    <Alert
      id={id}
      severity={batteryData.severity}
      icon={<Icon name={batteryData.iconName} style={{ fill: batteryData.drawerIconColor }} id="battery-status-icon" />}
      variant="standard"
      sx={{ backgroundColor: batteryData.backgroundColor }}
    >
      <Typography variant="body1" style={{ color: batteryData.textColor }} id="battery-status-label">
        {batteryData.boxText}
      </Typography>
    </Alert>
  );
};

export default BatteryStatusAlert;
